var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAddUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 18 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5625 7.125C8.33984 7.125 9.8125 5.67773 9.8125 3.875C9.8125 2.09766 8.33984 0.625 6.5625 0.625C4.75977 0.625 3.3125 2.09766 3.3125 3.875C3.3125 5.67773 4.75977 7.125 6.5625 7.125ZM7.83203 8.34375H5.26758C2.83008 8.34375 0.875 10.3242 0.875 12.7617C0.875 13.2441 1.25586 13.625 1.73828 13.625H11.3613C11.8438 13.625 12.25 13.2441 12.25 12.7617C12.25 10.3242 10.2695 8.34375 7.83203 8.34375ZM16.5156 5.70312H15.2969V4.48438C15.2969 4.1543 15.0176 3.875 14.6875 3.875C14.332 3.875 14.0781 4.1543 14.0781 4.48438V5.70312H12.8594C12.5039 5.70312 12.25 5.98242 12.25 6.3125C12.25 6.66797 12.5039 6.92188 12.8594 6.92188H14.0781V8.14062C14.0781 8.49609 14.332 8.75 14.6875 8.75C15.0176 8.75 15.2969 8.49609 15.2969 8.14062V6.92188H16.5156C16.8457 6.92188 17.125 6.66797 17.125 6.3125C17.125 5.98242 16.8457 5.70312 16.5156 5.70312Z",
    fill: "#555555"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddUser);
export default __webpack_public_path__ + "static/media/add-user.d0bf21711e3c9089db5d967d27710280.svg";
export { ForwardRef as ReactComponent };